<template>
    <v-content :style="{'background-image': `url('`+ require('../assets/bg-login.jpg') +`')`}"
               style="background-size: cover">
        <Header></Header>
        <v-layout justify-center>
            <v-flex xs12 style="background-color: #527281">
                <v-content>
                    <v-layout px-12 py-3>
                        <v-flex shrink style="text-align: left;">
                            <v-btn text small style="color: white;font-size: 18px" @click="$router.push('/home').catch(err => {})">
                                หน้าแรก
                            </v-btn>
                        </v-flex>
                        <v-icon style="color: white">play_arrow</v-icon>
                        <v-flex shrink style="text-align: left;">
                            <v-btn text small style="color: white;font-size: 18px">แก้ไขรหัสผ่าน</v-btn>
                        </v-flex>
                    </v-layout>
                </v-content>
            </v-flex>
        </v-layout>
        <v-layout justify-center>
            <v-flex xs12 sm10 md7 class="my-12 mb-4">
                <v-card class="py-12" style="border-radius: 25px;background: white; box-shadow: #2c3e50">
                    <v-layout>
                        <v-flex class="pb-6" style="font-size: 32px; color: #527281">
                            แก้ไขรหัสผ่าน
                        </v-flex>
                    </v-layout>
                    <v-layout justify-center>
                        <v-flex xs10 class="" style="font-size: 24px">
                            <v-form>
                                <v-layout class="form-edit-user" style="font-size: 18px">
                                    <v-flex md3 class="mr-4" style="text-align: right">
                                        รหัสผ่านเก่า :
                                    </v-flex>
                                    <v-flex md8>
                                        <v-text-field
                                                v-model="form.pass_old"
                                                type="password"
                                                background-color="#E5E5E5"
                                                solo
                                                required>
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout class="form-edit-user" style="font-size: 18px">
                                    <v-flex md3 class="mr-4" style="text-align: right">
                                        รหัสผ่านใหม่ :
                                    </v-flex>
                                    <v-flex md8>
                                        <v-text-field
                                                v-model="form.pass_new"
                                                type="password"
                                                background-color="#E5E5E5"
                                                solo
                                                required>
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout class="form-edit-user" style="font-size: 18px">
                                    <v-flex md3 class="mr-4" style="text-align: right">
                                        ยืนยันรหัสผ่านใหม่ :
                                    </v-flex>
                                    <v-flex md8>
                                        <v-text-field
                                                v-model="form.pass_new_confirm"
                                                type="password"
                                                background-color="#E5E5E5"
                                                solo
                                                required>
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>

                            </v-form>
                        </v-flex>
                    </v-layout>
                </v-card>
            </v-flex>
        </v-layout>
        <v-layout class="mb-12" justify-center>
            <v-flex shrink class="ma-2">
                <v-btn style="background-color: #BDBDBD; color: white;border-radius: 25px;" @click="$router.push('/home').catch(err => {})">ย้อนกลับ</v-btn>
            </v-flex>
            <v-flex shrink class="ma-2">
                <v-btn style="background-color: #527281; color: white;border-radius: 25px;" @click="onchangePasswprd()">ยืนยันการเปลี่ยนแปลงรหัสผ่าน</v-btn>
            </v-flex>
        </v-layout>

        <Footer></Footer>
    </v-content>
</template>

<script>
    import Header from "../components/Header";
    import Footer from "../components/Footer";
    import { mapState } from "vuex";

    export default {
        name: "ChangePasswordUser",
        components: {
            Footer,
            Header
        },
        computed: {
            // Map Vuex state.
            ...mapState({
                user: state => {
                    return state.Auth.user;
                },
            })
        },
        created() {

        },
        data: () => ({
            form: {
                pass_old: '',
                pass_new: '',
                pass_new_confirm: '',
            },

        }),
        methods: {
            onchangePasswprd() {
                let data = {
                    id: this.user.id,
                    pass_old: this.form.pass_old,
                    pass_new: this.form.pass_new,
                    pass_new_confirm: this.form.pass_new_confirm,
                };
                this.$store.dispatch('Auth/changePassword', data)
                    .then(data => {
                        alert('แก้ไขรหัสผ่านเรียบร้อยแล้ว')
                        alert('กรุณาเข้าสู่ระบบใหม่อีกครั้ง')
                        this.$store.dispatch('Auth/logout').then(() => {
                            // console.log('logout')
                            this.$router.push('/')
                        })
                    })
                    .catch(err => {
                        if(err.response.status === 401) {
                            alert(err.response.data.result)
                        } else {
                            console.log(500)
                        }

                        // alert('แก้ไขรหัสผ่านไม่สำเร็จ')
                    })
            }
        }
    }
</script>

<style scoped>

</style>
